/*
 * Customizer modal — name input, fur swatches, hat picker, unlock hints.
 */

import { $ } from '@/ui/modal';
import { save, persist } from '@/state/save';
import { FUR_COLORS } from '@/content/furColors';
import { HATS } from '@/content/hats';
import { PHRASES } from '@/content/phrases';

export interface CustomizerOptions {
  /** Called when the player picks a phrase from the say modal. */
  onPhrase: (phrase: string) => void;
}

export function initCustomizer(opts: CustomizerOptions): void {
  $('name-input').addEventListener('input', (e) => {
    const v = (e.target as HTMLInputElement).value.trim();
    if (v) {
      save.name = v;
      void persist();
    }
  });

  rebuildSwatches();
  rebuildHats();
  rebuildPhrases(opts.onPhrase);
}

export function rebuildSwatches(): void {
  const row = $('color-swatches');
  row.innerHTML = '';
  FUR_COLORS.forEach((c, i) => {
    const el = document.createElement('div');
    el.className = 'swatch' + (i === save.color ? ' selected' : '');
    el.style.background = c.body;
    el.addEventListener('click', () => {
      save.color = i;
      rebuildSwatches();
      void persist();
    });
    row.appendChild(el);
  });
}

export function rebuildHats(): void {
  const row = $('hat-options');
  row.innerHTML = '';
  HATS.forEach((h, i) => {
    const unlocked = !h.unlock || save.unlocks.includes(h.name);
    const el = document.createElement('div');
    el.className =
      'hat-option' +
      (i === save.hat ? ' selected' : '') +
      (unlocked ? '' : ' locked');
    el.textContent = h.name;
    el.addEventListener('click', () => {
      if (!unlocked) {
        $('hat-hint').textContent = '🔒 ' + (h.hint ?? '');
        return;
      }
      save.hat = i;
      rebuildHats();
      void persist();
      $('hat-hint').textContent = '';
    });
    row.appendChild(el);
  });
}

function rebuildPhrases(onPhrase: (p: string) => void): void {
  const grid = $('phrase-grid');
  grid.innerHTML = '';
  PHRASES.forEach((p) => {
    const el = document.createElement('button');
    el.className = 'phrase-btn';
    el.type = 'button';
    el.textContent = p;
    el.addEventListener('click', () => onPhrase(p));
    grid.appendChild(el);
  });
}
